import styled from "@emotion/styled";

import { BaseLink } from "~/components/common/base-link";

import Logo from "./logo.svg";

export const StyledLogo = styled(Logo)``;

export const StyledLogoLink = styled(BaseLink)``;
